module.exports = __webpack_public_path__ + "public/images/icons/travelata.66bdf58fa83757241ae00d86339f70d7.png";